export const TERM_PARAM = 'term';
export function getTermFromSearch(search) {
  var _params$get;
  const params = new URLSearchParams(search);
  return ((_params$get = params.get(TERM_PARAM)) === null || _params$get === void 0 ? void 0 : _params$get.toUpperCase()) === 'MONTHLY' ? 'MONTHLY' : 'ANNUAL';
}